


















































import UsersList from "@/components/admin/users/UsersListForm.vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import { getCurrentUserId, isRoot } from "@/plugins/roles";
import { Company as ICompany } from "@/api/models/company";
import company, { CompanyListParams } from "@/getinfo-api/company";
import { uniqBy } from "lodash";

@Component({
  components: { UsersList }
})
export default class CompaniesListView extends Vue {
  companies: Array<ICompany> = [];
  limit: number = 30;
  offset: number = 0;
  companiesCount!: number;
  isLoading: boolean = false;
  sortElem?: boolean;
  title: string = "";
  isCompanyEnabled: boolean = true;

  data() {
    return {
      sortElem: false,
      companiesCount: undefined
    };
  }

  sortCompanyList() {
    this.sortElem = !this.sortElem;
  }

  filterCompanies() {
    if (this.sortElem) {
      return this.companies?.sort((a, b) =>
        b.title.toLowerCase() > a.title.toLowerCase() ? 1 : -1
      );
    } else {
      return this.companies?.sort((a, b) =>
        a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1
      );
    }
  }

  get root() {
    return isRoot();
  }

  get userId() {
    return getCurrentUserId();
  }

  showMore() {
    this.offset += this.limit;
    this.getCompanies(this.offset);
  }

  async getCompaniesEnabled(offset: number = 0) {
    this.offset = 0;
    this.companies = [];
    try {
      this.isLoading = true;
      const params: CompanyListParams = {
        title: this.title?.length ? this.title : undefined,
        enabled: this.isCompanyEnabled,
        employeesIds: this.root ? undefined : [this.userId],
        limit: this.limit,
        offset: offset
      };
      const { data } = await company(params);
      this.companiesCount = data.count;
      this.companiesCount = this.companiesCount - 1;
      this.companies = [...this.companies, ...data.companies];
      this.filterCompanies();
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  async getCompanies(offset: number = 0) {
    try {
      this.isLoading = true;
      const params: CompanyListParams = {
        title: this.title?.length ? this.title : undefined,
        enabled: this.isCompanyEnabled,
        employeesIds: this.root ? undefined : [this.userId],
        limit: this.limit,
        offset: offset
      };
      const { data } = await company(params);
      this.companiesCount = data.count;
      this.companiesCount = this.companiesCount - 1;
      this.companies = [
        ...uniqBy(this.companies, "title"),
        ...uniqBy(data.companies, "id")
      ];
      this.filterCompanies();
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  @Watch("sortElem")
  sortList() {
    this.filterCompanies();
  }

  @Watch("title")
  upd() {
    this.companies = [];
    this.companiesCount = 0;
    this.offset = 0;
    this.getCompanies();
  }

  created() {
    this.getCompanies();
  }
}
